module.exports = __webpack_public_path__ + "img/qian_bg_zhTc.ca14a415.png";